export default __webpack_public_path__ + "static/media/231.21dd97b8.pdf";